import type { Feature } from '@exodus/dependency-types';

import airdropApiDefinition from './api.js';
import airdropDefinition from './module.js';

const airdrop = () =>
  ({
    id: 'airdrop',
    definitions: [
      { definition: airdropDefinition },
      { definition: airdropApiDefinition },
    ],
  }) satisfies Feature;

export default airdrop;
